import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/Login';
import { MainLayout } from './layouts/MainLayout';
import { DashboardPage } from './pages/Dashboard';
import { TenantsListPage } from './pages/TenantsList';
import { TenantCreatePage } from './pages/TenantCreate';
import { TenantDetailPage } from './pages/TenantDetail';
import { TenantRenewPage } from './pages/TenantRenew';
import { JobsPage } from './pages/Jobs';
import { AdminsPage } from './pages/Admins';
import { ModelProvidersPage } from './pages/ModelProviders';
import { UsagePage } from './pages/usage/UsagePage';
import { TenantUsageDetail } from './pages/usage/TenantUsageDetail';
import { RequireAdmin } from './components/RequireAdmin';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<MainLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/tenants" element={<TenantsListPage />} />
        <Route path="/tenants/new" element={<TenantCreatePage />} />
        <Route path="/tenants/:id" element={<TenantDetailPage />} />
        <Route path="/tenants/:id/renew" element={<TenantRenewPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/usage" element={<UsagePage />} />
        <Route path="/usage/tenants/:id" element={<TenantUsageDetail />} />
        <Route path="/admins" element={<RequireAdmin><AdminsPage /></RequireAdmin>} />
        <Route path="/model-providers" element={<ModelProvidersPage />} />
      </Route>
    </Routes>
  );
}
